export const state = {
  // product: undefined,
  // products: []
  user: {},
  users: [],
}
